"use strict";

module.exports = {
  DRAFT: 'DRAFT',
  PUBLISHED: 'PUBLISHED',
  INTERNAL: 'INTERNAL',
  ARCHIVED: 'ARCHIVED'
};